import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem } from "./Components";

import hea_haz_lev from "../img/sswpIcons/HealthAssess/hea_haz_lev.png";
import hea_eff from "../img/sswpIcons/HealthAssess/hea_ass_hea_eff.png";
import hea_sur from "../img/sswpIcons/HealthAssess/hea_mon_sur.png";
import hea_bio_age from "../img/sswpIcons/HealthAssess/hea_bio_age.png";
import hea_dec_uni from "../img/sswpIcons/HealthAssess/hea_dec_uni.png";
import hea_har_gas_dus from "../img/sswpIcons/HealthAssess/hea_har_gas_dus.png";
import hea_syr from "../img/sswpIcons/HealthAssess/hea_syr.png";
import hea_vac from "../img/sswpIcons/HealthAssess/hea_vac.png";
import hea_sit_spe_met from "../img/sswpIcons/HealthAssess/hea_sit_spe_met.png";

const json = {
    icon: hea_haz_lev,
    name: "Health",
    text: "",
    icons: {
        hea_ass_hea_eff: {
            name: "Assess Health Effects",
            icon: hea_eff,
            text: (
                <ul>
                    <ListItem text="Assess likelihood of repetitive strain injury and put in place the  appropriate controls" />
                    <ListItem text="Organise break and rest periods" />
                    <ListItem text="Assess risk presented by chemical, biological or physical (e.g. dust) agents and put in place the appropriate controls." />
                    <Li>
                        <Typography variant="title">
                            Follow the Control of Risk Hierarchy in the
                            following order
                        </Typography>
                        <ol>
                            <ListItem text="Eliminate (remove of replace the hazard)" />
                            <ListItem text="Substitute (can a less risky method be used)" />
                            <ListItem text="Isolate (segregate hazard, enclose)" />
                            <ListItem text="Control (Is there a tool or method to control the risk)" />
                            <ListItem text="Management Controls (follow SOPs, SDS)" />
                            <ListItem text="PPE (Use the correct PPE)" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        hea_har_gas_dus: {
            name: "Harmful Gases and Dusts",
            icon: hea_har_gas_dus,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            These can present a health risk through contact with
                            the skin or eyes, or through inhalation. The
                            following controls should be considered
                        </Typography>
                        <ol>
                            <ListItem text="Surveying and Monitoring for the presence of a harmful gases or dusts. If the air quality is not suitable then the areas cannot be inhabited and should be treated as a confined space." />
                            <ListItem text="Use a permit to work system to control access (personnel and timings)" />
                            <ListItem text="Use ventilation methods to maintain proper air quality" />
                            <ListItem text="Use an exhaust system to remove dust" />
                            <ListItem text="Use damping and wetting techniques to control dust" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        hea_bio_age: {
            name: "Biological Agent",
            icon: hea_bio_age,
            text: (
                <ul>
                    <ListItem text="This covers exposure to bacteria, viruses, parasites, fungi and Weil’s disease" />
                    <ListItem text="Thoroughly examine the area to assess the risk" />
                    <ListItem text="Ensure people who are exposed to these risks have been vaccinated (eg. Hepatitis). If appropriate, use a permit to work system to control access to the effected area." />
                    <Li>
                        <Typography variant="title">
                            All operatives must wear PPE
                        </Typography>
                        <ol>
                            <ListItem text="Gloves" />
                            <ListItem text="Mask" />
                            <ListItem text="Overalls" />
                        </ol>
                    </Li>
                    <ListItem text="After use, dispose of discarded PPE safely." />
                </ul>
            )
        },
        hea_syr: {
            name: "Syringes",
            icon: hea_syr,
            text: (
                <ul>
                    <ListItem text="This hazard is present in many derelict buildings and seldom used public areas." />
                    <ListItem text="You must have appropriate training." />
                    <ListItem text="You should use litter pickers and not lift syringes with your hands, even if wearing gloves." />
                    <Li>
                        <Typography variant="title">

                        You must wear appropriate PPE

                        </Typography>
                        <ol>
                            <ListItem text="Penetration resistance safety footwear" />
                            <ListItem text="Cut Resistant Gloves (Grouping Category 3)" />
                        </ol>
                    </Li>
                    <ListItem text="You must be provided with and use designated containers for disposal." />
                </ul>
            )
        },
        hea_mon_sur: {
            name: "Health Monitoring/Surveillance",
            icon: hea_sur,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            Subject to your organisation’s safety management
                            system, you may be required to undergo a range of
                            health checks, including
                        </Typography>
                        <ListItem text="Vaccinations" />
                        <ListItem text="Audiometry and Eye Tests" />
                        <ListItem text="Health questionnaires" />
                        <ListItem text="Medical checks (to identify asthma, dermatitis etc)" />
                        <ListItem text=" Spirometry (lung function tests)" />
                    </Li>
                </ul>
            )
        },

        hea_vac: {
            name: "Vaccination Programme",
            icon: hea_vac,
            text: (
                <ul>
                    <ListItem text="You must comply with your organisations vaccination policy. This policy must account for the risk of exposure, and likelihood of contamination" />
                    <Li>
                        <Typography variant="title">
                            Vaccination policies will generally cover
                        </Typography>
                        <ol>
                            <ListItem text="Anti-Tetanus: The Tetanus bacterium lives in soil, and can enter the body through a wound usually from an infected object such as a nail, wood splinter or thorn. Commonly known as lockjaw, after about a week of incubation, the disease commonly causes stiffness around the jaw area before spreading to other muscles. It can be fatal. Booster should be obtained every few years." />
                            <ListItem text="Hepatitis A: Exposure to raw or untreated sewerage. It can enter the body through inadvertent ingestion via contaminated objects, food or drinks. Symptoms are usually mild and don’t appear for a few weeks; fatigue, nausea, abdominal pain, clay-coloured bowel movements, loss of apetitie, low-grade fever, dark urine, joint pain, itching, jaundice." />
                            <ListItem text="Hepatitis B: Exposure to blood borne viruses. It can enter the body by puncture with a contaminated object. It effects the liver. Symptoms can be mild to severe and can present as early as 2 weeks; abdominal pain, dark urine, fever, joint pain, loss of appetite, nausea, fatigue, jaundice." />
                        </ol>
                    </Li>
                    <ListItem text="You should always follow the physical controls identified to prevent contamination, and have serviced and clean first aid equipment available." />
                </ul>
            )
        },

        hea_dec_uni: {
            name: "Decontamination Unit",
            icon: hea_dec_uni,
            text: (
                <ul>
                    <ListItem text="A purpose built decontamination unit is required for operatives involved in removing asbestos, to allow them to change out of PPE into normal outdoor clothing. " />
                    <ListItem text="It must be the first piece of equipment to arrive on such sites and must be the last to leave." />
                    <Li>
                        <Typography variant="title">
                            It contains 3 areas; Dirty room leading to shower
                            room leading to clean room.
                        </Typography>
                        <ListItem text="The dirty room is where you remove your PPE with the exception of your respirator. The PPE must remain in this room until it is decontaminated. You remove your PPE by rolling the dirty side of your suit away from you. Turn the sleeves inside out when removing your arms. Place the suit in a disposable bag or other container and proceed to shower while wearing your respirator." />
                        <ListItem text="Soap and towels must be provided in the shower room. Wet your entire body to control any fibres that may be on you. Take a breath while wearing your respirator and then wet your face. Take a breath, turn away, remove your respirator and wet your face in the shower again (this reduces risk of breathing any fibres on your face or respirator). Either clean your respirator in the shower or place it in a container for cleaning. Leave the shower and enter the clean room." />
                    </Li>
                </ul>
            )
        },
        hea_sit_spe_met: {
            name: "Site Specific Method Statement/ Design",
            icon: hea_sit_spe_met,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};
export default json;
